// ============================================================================
// OBT F3-C — Rapor biçimlendirme (Türkçe) + CSV dışa aktarma
// ============================================================================
// Yüzde/süre biçimlendirme + CSV (Blob + BOM) indirme. Excel/PDF backend
// tarafından ÜRETİLMEDİĞİNDEN sahte export YAZILMAZ (yalnız gerçek CSV).
// ============================================================================

/** 0..1 oranı Türkçe yüzde metnine. null → "—". */
export function formatPercent(ratio, digits = 0) {
  if (ratio === null || ratio === undefined || Number.isNaN(ratio)) return '—';
  return `%${(ratio * 100).toFixed(digits)}`;
}

/** Saniyeyi okunur Türkçe süreye (null → "—"). */
export function formatDuration(seconds) {
  if (seconds === null || seconds === undefined || Number.isNaN(seconds)) return '—';
  const s = Math.max(0, Math.round(Number(seconds)));
  if (s < 60) return `${s} sn`;
  const m = Math.round(s / 60);
  if (m < 60) return `${m} dk`;
  const h = Math.floor(s / 3600);
  const rem = Math.round((s % 3600) / 60);
  if (h < 24) return rem ? `${h} sa ${rem} dk` : `${h} sa`;
  const d = Math.floor(s / 86400);
  const hr = Math.round((s % 86400) / 3600);
  return hr ? `${d} gün ${hr} sa` : `${d} gün`;
}

/** ISO tarih → Türkçe kısa tarih; boşsa "—". */
export function formatDate(iso) {
  if (!iso) return '—';
  const t = Date.parse(iso);
  if (Number.isNaN(t)) return '—';
  return new Date(t).toLocaleDateString('tr-TR', {
    timeZone: 'Europe/Istanbul',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
}

/** İnceleme süresi stage'i için Türkçe etiket. */
export const DURATION_STAGE_LABELS = Object.freeze({
  created_to_published: 'Oluşturma → Yayın',
  published_to_response: 'Yayın → Cevap (ortalama cevap süresi)',
  bm_review: 'BM incelemesi',
  my_review: 'MY incelemesi',
  director_decision: 'Müdür kararı',
  total_resolution: 'Toplam çözüm süresi',
});

// --- CSV dışa aktarma (gerçek veri; Blob + UTF-8 BOM Excel uyumu) -------------

function csvCell(value) {
  if (value === null || value === undefined) return '';
  const s = String(value);
  if (/[",\n;]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

/**
 * Satır/kolon dizilerinden CSV metni üretir (ilk satır başlık).
 * @param {string[]} headers
 * @param {Array<Array<string|number|null>>} rows
 */
export function toCsv(headers, rows) {
  const head = (headers || []).map(csvCell).join(';');
  const body = (rows || []).map((r) => (r || []).map(csvCell).join(';')).join('\n');
  return body ? `${head}\n${body}` : head;
}

/**
 * CSV'yi tarayıcıda indir (Blob + BOM + anchor). Test ortamında (URL API yoksa)
 * sessizce false döner.
 */
export function downloadCsv(filename, csvText) {
  try {
    const blob = new Blob(['﻿' + csvText], {
      type: 'text/csv;charset=utf-8;',
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    return true;
  } catch {
    return false;
  }
}
